module.exports = __webpack_public_path__ + "img/crowd.c089f006.jpg";